import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme/myPalette'

export const Title = styled.div`
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 8px;
`
export const Label = styled.div`
  color: ${myPalette.blue.lightSteelBlue};
  font-size: 16px;
  margin-bottom: 8px;
`
export const Field = styled.div`
  color: ${myPalette.midnightBlue.main};
  font-size: 16px;
  margin-bottom: 8px;
`
